module.exports = __webpack_public_path__ + "static/media/griddark.1dc8b05e.svg";